module.exports = __webpack_public_path__ + "static/media/header-1.00ec3f52.jpg";